export const AWS_ERRORS_CODE_TO_MESSAGE: {[key: string]: string} = {
  LimitExceededException: 'Attempts are too many, try later',
  NotAuthorizedException: 'You entered the wrong password'
}

export const INTERNAL_SERVER_ERROR = 'Server error, please try later'
